import React from 'react';
import { Tooltip } from '@mui/material';
import FeedbackIcon from '@mui/icons-material/Feedback';

export type ArrayTableCellData = {
  value: string;
  tooltips?: string;
  helperText?: string;
};

export const getArrayTableCell = (
  cellData: ArrayTableCellData[],
): React.ReactNode => {
  return (
    <>
      {cellData?.map((data, index) => {
        const { value, tooltips, helperText } = data;
        return (
          <div
            key={index}
            className="w-full text-left  mb-2 flex items-baseline"
          >
            <Tooltip
              title={tooltips ?? value}
              placement="bottom"
              className="whitespace-nowrap overflow-hidden text-ellipsis"
            >
              <span>{value}</span>
            </Tooltip>
            {helperText && (
              <Tooltip title={helperText} arrow>
                <FeedbackIcon style={{ color: '#951d1d' }} fontSize="small" />
              </Tooltip>
            )}
          </div>
        );
      })}
    </>
  );
};
